import { type EPaResponse } from 'store/api/epaApi';

export interface SubmittedResponseText {
    question: string | number;
    answer: string;
}

export const getSubmittedAnswers = (activeResponse?: EPaResponse): SubmittedResponseText[] =>
    activeResponse?.questionSet?.answers
        ?.map((answer) => {
            const questionText = activeResponse.questionSet?.nodes?.find(
                (node) => String(node.question_id) === String(answer.question_id),
            )?.question_text;
            const selectedOptionText = answer.selected_options
                .map((option) => option.answer)
                .join(', ');
            const responseText = [selectedOptionText, answer.additional_free_text]
                .filter(Boolean)
                .join(' | ');

            if (!responseText) {
                return undefined;
            }

            const returnAnswer = {
                question: questionText ?? answer.question_id,
                answer: responseText ?? '',
            };
            return returnAnswer;
        })
        .filter((value): value is SubmittedResponseText => value !== undefined) ?? [];
